import type { Dictionary } from 'lodash' // eslint-disable-line lodash/import-scope
import { useShallow } from 'zustand/shallow'

import { useStore, getIncomingCollapsedNodesSelector } from '@app/store'
import type { DomainObject, DomainNode } from '@app/types'

type GroupObject = { rfId?: string } & DomainObject
type UseGetIncomingCollapsedNodes = (node: DomainNode) => {
  nodes: DomainNode[]
  groups: Dictionary<GroupObject[]>
  confidenceScore?: number | string
}

const useGetIncomingCollapsedNodes: UseGetIncomingCollapsedNodes = (node) =>
  useStore(useShallow((state) => getIncomingCollapsedNodesSelector(state, node)))

export default useGetIncomingCollapsedNodes
